import { render, staticRenderFns } from "./AddOns.vue?vue&type=template&id=10025e10&scoped=true"
import script from "./AddOns.vue?vue&type=script&lang=js"
export * from "./AddOns.vue?vue&type=script&lang=js"
import style0 from "./AddOns.vue?vue&type=style&index=0&id=10025e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10025e10",
  null
  
)

export default component.exports